import { render } from "./locales.vue?vue&type=template&id=3ec3022a"
import script from "./locales.vue?vue&type=script&lang=js"
export * from "./locales.vue?vue&type=script&lang=js"

import exportComponent from "/home/apps/ru_dnmsk/production/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__